exports.components = {
  "component---src-pages-cms-preview-index-tsx": () => import("./../../../src/pages/cms-preview/index.tsx" /* webpackChunkName: "component---src-pages-cms-preview-index-tsx" */),
  "component---src-templates-page-index-tsx": () => import("./../../../src/templates/Page/index.tsx" /* webpackChunkName: "component---src-templates-page-index-tsx" */)
}

